import React from 'react';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';

export const CourseHomePageBreadcrumb = ({courseName}) => {
    return (
        <Breadcrumb>
            <BreadcrumbItem active>{courseName}</BreadcrumbItem>
        </Breadcrumb>
    );
};

export default CourseHomePageBreadcrumb;
